import React, { useEffect, useRef } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import HeroCarousel from '../components/HeroCarousel';
import ContactForm from '../components/ContactForm';
import PlanosAvulsos from '../components/PlanosAvulsos';
import FaqSection from '../components/FaqSection';
import Testimonials from '../components/Testimonials';
import AppPromoPopup from '../components/AppPromoPopup';
import Footer from '../components/Footer';
import './HomePage.css';
import './ContactSection.css';

const HOME_WHATSAPP_URL = 'https://wa.me/5521987940668?text=Ola!%20Quero%20consultar%20a%20viabilidade%20de%20internet%20para%20o%20meu%20endereco.';

const IconPix = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round">
    <path d="M7 7h10a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2Z" />
    <path d="M9 7V5.5A1.5 1.5 0 0 1 10.5 4h3A1.5 1.5 0 0 1 15 5.5V7" />
    <path d="M8.5 12h7" />
    <path d="M12 9.5v5" />
  </svg>
);

const IconKey = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="8.5" cy="14.5" r="3.5" />
    <path d="M11 12l7-7" />
    <path d="M17 5h2v2" />
    <path d="M14.5 8.5l1 1" />
  </svg>
);

const IconClipboard = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round">
    <rect x="6" y="4" width="12" height="16" rx="2" />
    <path d="M9 4.5h6" />
    <path d="M9 10h6" />
    <path d="M9 14h6" />
    <path d="M9 18h4" />
  </svg>
);

const IconUserEdit = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="10" cy="8" r="3.5" />
    <path d="M4 20c.6-3.4 3.2-5.5 6-5.5.9 0 1.7.2 2.5.6" />
    <path d="m17.4 14.6 3 3-4.2 4.2H13v-3.2z" />
  </svg>
);

const QUICK_ACTIONS = [
  { id: 'pix', label: 'Pague com Pix', description: 'Acesse sua cobrança e quite sua fatura na hora.', icon: IconPix, to: '/2via' },
  { id: 'senha', label: 'Troca de Senha', description: 'Solicite a alteração da senha do Wi-Fi ou da Central do Assinante.', icon: IconKey, to: '/solicitacoes?acao=troca-senha' },
  { id: 'os', label: 'Consulta de O.S.', description: 'Veja o andamento dos chamados já abertos e finalizados.', icon: IconClipboard, to: '/solicitacoes?acao=consultar-chamados' },
  { id: 'cadastro', label: 'Atualização Cadastral', description: 'Atualize seus dados, como telefone, e-mail e endereço.', icon: IconUserEdit, to: '/solicitacoes?acao=atualizacao-cadastral' },
];

const APPS = [
  {
    id: 'faynet',
    nome: 'FayNet',
    subtitulo: 'Aplicativo do CHIP',
    descricao: 'Aplicativo para acompanhar o consumo e as informações do seu CHIP.',
    icone: '/index/faynetaplicativo.webp',
    androidLink: 'https://play.google.com/store/apps/details?id=com.nectarlabs.mvno.faynet.app&hl=pt_BR',
    iosLink: 'https://apps.apple.com/br/app/fay-net/id6759068478',
  },
  {
    id: 'zapping',
    nome: 'Zapping',
    subtitulo: 'Aplicativo de TV',
    descricao: 'Aplicativo para acessar os conteúdos e serviços de TV da Zapping.',
    icone: '/index/zapping.webp',
    androidLink: 'https://play.google.com/store/apps/details?id=com.eltelon.zapping&hl=pt_BR',
    iosLink: 'https://apps.apple.com/br/app/zapping/id1140533675',
  },
  {
    id: 'leveduca',
    nome: 'LevEduca',
    subtitulo: 'Aplicativo Educacional',
    descricao: 'Aplicativo para acesso aos conteúdos e recursos educacionais disponibilizados aos clientes.',
    icone: '/index/leveduca.webp',
    androidLink: 'https://play.google.com/store/apps/details?id=com.nubbi.leveduca&hl=pt_BR',
    iosLink: 'https://apps.apple.com/br/app/leveduca/id1571292964',
  },
];

const IconGooglePlay = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M5 3.5v17l14-8.5L5 3.5Z" />
  </svg>
);

const IconApple = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M12.152 6.896c-.948 0-2.415-1.078-3.96-1.04-2.04.027-3.91 1.183-4.961 3.014-2.117 3.675-.546 9.103 1.519 12.09 1.013 1.454 2.208 3.09 3.792 3.039 1.52-.06 2.098-.987 3.938-.987 1.839 0 2.362.987 3.973.948 1.637-.026 2.671-1.48 3.676-2.948 1.156-1.689 1.636-3.325 1.662-3.415-.037-.014-3.182-1.226-3.213-4.85-.028-3.03 2.474-4.483 2.585-4.549-1.415-2.081-3.617-2.312-4.389-2.361-2-.16-3.675 1.088-4.622 1.088zm3.41-3.114c.845-1.023 1.417-2.445 1.26-3.86-1.214.049-2.683.809-3.55 1.832-.786.907-1.472 2.36-1.288 3.751 1.36.106 2.73-.694 3.578-1.723z" />
  </svg>
);

function HomePage() {
  const heroMsaRef = useRef(null);
  const planosRef = useRef(null);
  const contactRef = useRef(null);
  const location = useLocation();
  const navigate = useNavigate();

  const renderQuickActions = (cardClassName = 'home-quick-actions__card') => (
    <div className="home-quick-actions">
      <div className="home-quick-actions__track">
        {QUICK_ACTIONS.map((action) => {
          const Icon = action.icon;
          return (
            <Link key={action.id} to={action.to} className={cardClassName}>
              <span className="home-quick-actions__icon"><Icon /></span>
              <span className="home-quick-actions__body">
                <strong className="home-quick-actions__label">{action.label}</strong>
                <span className="home-quick-actions__description">{action.description}</span>
              </span>
            </Link>
          );
        })}
      </div>
    </div>
  );

  // Rola até o FAQ quando a Home é aberta a partir do link FAQ do navbar em outra página
  useEffect(() => {
    if (location.state?.scrollTo === 'faq') {
      const timer = window.setTimeout(() => {
        document.getElementById('faq')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
        navigate(location.pathname, { replace: true, state: {} });
      }, 150);
      return () => window.clearTimeout(timer);
    }
    return undefined;
  }, [location.state, location.pathname, navigate]);

  useEffect(() => {
    const observerOptions = {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('animate-in');
        }
      });
    }, observerOptions);

    if (heroMsaRef.current) observer.observe(heroMsaRef.current);
    if (planosRef.current) observer.observe(planosRef.current);
    if (contactRef.current) observer.observe(contactRef.current);

    return () => observer.disconnect();
  }, []);

  return (
    <div>
      <AppPromoPopup />

      {/* Seção apresentação - Banner Faynet */}
      <section className="hero-msa" ref={heroMsaRef}>
        <div className="hero-msa__banner">
          <HeroCarousel />
        </div>
      </section>

      <section className="home-mobile-actions" aria-label="Acessos frequentes">
        <div className="home-mobile-actions__faq-band">
          <div className="home-mobile-actions__faq-inner">
            <span className="home-mobile-actions__eyebrow">Serviços Mais Buscados</span>
          </div>
        </div>

        <div className="home-mobile-actions__inner">
          {renderQuickActions('home-quick-actions__card home-quick-actions__card--mobile')}
        </div>
      </section>

      {/* Seção Planos de internet avulsa */}
      <section className="home-planos" id="home-planos" ref={planosRef}>
        <div className="home-planos__cta">
          <div className="home-planos__cta-top">
            <p className="home-planos__cta-text">Precisa de ajuda ou tem alguma dúvida? Fale com um de nossos especialistas</p>
            <a
              href={HOME_WHATSAPP_URL}
              target="_blank"
              rel="noreferrer"
              className="home-planos__cta-btn"
            >
              CHAMAR NO WHATSAPP
            </a>
          </div>

          {renderQuickActions()}
        </div>
        <div className="home-planos__header">
          <span className="home-planos__eyebrow">Planos de internet</span>
          <h2 className="home-planos__title">Escolha o plano ideal para você</h2>
          <p className="home-planos__subtitle">
            Temos o plano certo para o seu perfil, com velocidade, estabilidade e o melhor custo-beneficio.
          </p>
        </div>
        <div className="home-planos__wrapper">
          <PlanosAvulsos showViewAllLink mobileShowcase />
        </div>
      </section>

      {/* Seção Aplicativos */}
      <section className="home-apps" aria-label="Aplicativos disponíveis">
        <div className="home-apps__header">
          <span className="home-apps__eyebrow">📱 Aplicativos</span>
          <h2 className="home-apps__title">Baixe os aplicativos Faynet</h2>
          <p className="home-apps__subtitle">
            Tenha na palma da mão o controle do seu CHIP, os conteúdos de TV e os recursos educacionais.
          </p>
        </div>
        <div className="home-apps__grid">
          {APPS.map((app) => (
            <div key={app.id} className="home-apps__card">
              <img src={app.icone} alt={`Ícone do aplicativo ${app.nome}`} className="home-apps__icon" loading="lazy" />
              <div className="home-apps__body">
                <strong className="home-apps__name">{app.nome}</strong>
                <span className="home-apps__subtitle-tag">{app.subtitulo}</span>
                <p className="home-apps__description">{app.descricao}</p>
              </div>
              <div className="home-apps__downloads">
                <a
                  href={app.androidLink}
                  target="_blank"
                  rel="noreferrer"
                  className="home-apps__store-btn home-apps__store-btn--android"
                  aria-label={`Baixar ${app.nome} na Google Play`}
                >
                  <IconGooglePlay />
                  <span className="home-apps__store-label">
                    <small>Disponível no</small>
                    <strong>Google Play</strong>
                  </span>
                </a>
                <a
                  href={app.iosLink}
                  target="_blank"
                  rel="noreferrer"
                  className="home-apps__store-btn home-apps__store-btn--ios"
                  aria-label={`Baixar ${app.nome} na App Store`}
                >
                  <IconApple />
                  <span className="home-apps__store-label">
                    <small>Disponível na</small>
                    <strong>App Store</strong>
                  </span>
                </a>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Depoimentos de Clientes */}
      <Testimonials />

      {/* Seção Fale Conosco */}
      <section className="contact-section" ref={contactRef}>
        <div className="contact-section__wrapper">
          {/* Lado esquerdo - Formulário */}
          <div className="contact-section__left">
            <div className="contact-section__header">
              <h2 className="contact-section__title">Fale com a Faynet</h2>
              <p className="contact-section__subtitle">
                Dúvidas, planos, parcerias, reclamacoes ou qualquer outro assunto: preencha o formulário e nossa equipe entrará em contato em até 24 horas.
              </p>
            </div>
            <ContactForm />
          </div>

          {/* Lado direito - Imagem Notebook */}
          <div className="contact-section__right">
            <img 
              src="/index/inicio3.png" 
              alt="Sistema MSA Porta Paletes - Tecnologia e Inovação" 
              className="contact-section__image"
            />
          </div>
        </div>
      </section>

      {/* Perguntas frequentes */}
      <FaqSection />

      <Footer />
    </div>
  );
}

export default HomePage;
